import React from "react";

function Heading({children}){
    return <h2 className="text-xl">
        {children}
    </h2>

}

export default Heading